import React, { ReactElement } from 'react'
import { CourierService } from './types/models'

type CourierServiceOptionProps = {
  courierService: CourierService;
  isSelected: boolean;
  setSelectedCourierService: (courierService: CourierService) => void;
}

const CourierServiceOption = (
  { courierService, isSelected, setSelectedCourierService }: CourierServiceOptionProps
): ReactElement => {
  const formatter = new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP'
  })

  const shippingAmount = () => {
    const amount = parseFloat(courierService.shipping_amount)
    if (amount > 0) {
      return formatter.format(amount)
    }
    return 'Free'
  }

  return (
    <button
      type="button"
      name="delivery_slot"
      className={`delivery-slot-button ${isSelected ? 'selected' : ''}`}
      onClick={(): void => setSelectedCourierService(courierService)}
    >
      <span className="delivery-slot-label">{courierService.label}</span>
      <span className="delivery-slot-price">{shippingAmount()}</span>
    </button>
  )
}

export default CourierServiceOption
